import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Inbox, Trash2, Mail, Phone } from "lucide-react";
import { http, formatApiError } from "../lib/api";

const STATUS = { new: ["Nouveau", "bg-sky-100 text-sky-800"], in_progress: ["En cours", "bg-amber-100 text-amber-800"], done: ["Traité", "bg-emerald-100 text-emerald-800"], archived: ["Archivé", "bg-slate-100 text-slate-600"] };

export default function SiteContacts() {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => http.get("/site-contacts").then((r) => setRows(r.data)).catch((e) => toast.error(formatApiError(e))), []);
  useEffect(() => { load(); }, [load]);
  const setStatus = async (c, status) => { try { await http.patch(`/site-contacts/${c.id}`, { status }); load(); } catch (e) { toast.error(formatApiError(e)); } };
  const del = async (c) => { if (!window.confirm(`Supprimer la demande de ${c.name} ?`)) return; try { await http.delete(`/site-contacts/${c.id}`); load(); } catch (e) { toast.error(formatApiError(e)); } };
  return (
    <div className="p-8 max-w-[1800px] mx-auto" data-testid="site-contacts-page">
      <h1 className="font-display text-4xl font-extrabold tracking-tight flex items-center gap-3"><Inbox className="h-8 w-8" />Contacts site</h1>
      <p className="text-sm text-slate-600 mb-6">Demandes reçues depuis le site Solutions PRIME · copie envoyée à contact@solutions-prime.fr</p>
      <div className="space-y-3">
        {rows.length === 0 && <p className="text-sm text-slate-500 border border-dashed border-slate-300 rounded-md p-10 text-center">Aucune demande pour l'instant.</p>}
        {rows.map((c) => (
          <div key={c.id} data-testid={`site-contact-${c.id}`} className="border border-slate-200 bg-white rounded-md p-5">
            <div className="flex flex-wrap items-center gap-3">
              <span className="font-bold">{c.name}</span>{c.company && <span className="text-slate-500">· {c.company}</span>}
              <span className={`text-[11px] font-bold px-2 py-0.5 rounded-full ${STATUS[c.status]?.[1]}`}>{STATUS[c.status]?.[0]}</span>
              <span className="ml-auto text-xs text-slate-500">{new Date(c.created_at).toLocaleString("fr-FR")}</span>
            </div>
            <div className="flex flex-wrap gap-4 text-sm mt-2 text-slate-600">
              <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1 hover:underline"><Mail className="h-3.5 w-3.5" />{c.email}</a>
              {c.phone && <a href={`tel:${c.phone}`} className="inline-flex items-center gap-1 hover:underline"><Phone className="h-3.5 w-3.5" />{c.phone}</a>}
              {c.pole && <span className="font-semibold text-slate-700">{c.pole}</span>}
            </div>
            <p className="text-sm mt-3 whitespace-pre-wrap">{c.message}</p>
            <div className="flex items-center gap-2 mt-4">
              <select data-testid={`site-contact-status-${c.id}`} value={c.status} onChange={(e) => setStatus(c, e.target.value)} className="border border-slate-300 rounded-md px-2 py-1 text-sm">
                {Object.entries(STATUS).map(([k, [l]]) => <option key={k} value={k}>{l}</option>)}
              </select>
              <button type="button" data-testid={`site-contact-delete-${c.id}`} onClick={() => del(c)} className="ml-auto p-1.5 rounded hover:bg-rose-50"><Trash2 className="h-4 w-4 text-rose-600" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
